import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const Bolt = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 14 23'} {...props}>
    <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.51953 0.8125C7.78711 0.411553 8.2931 0.241325 8.74805 0.399414V0.400391C9.20414 0.559668 9.49514 1.0071 9.45508 1.48828L8.88184 8.37207L8.85059 8.74121H12.5996C12.9841 8.74121 13.3387 8.95011 13.5254 9.28613C13.6886 9.58104 13.7018 9.93343 13.5654 10.2354L13.4971 10.3613L6.49707 21.5615C6.29968 21.8769 5.95675 22.0586 5.59961 22.0586C5.54472 22.0586 5.4895 22.0546 5.43457 22.0459L5.26953 22.0059C4.83535 21.8631 4.5448 21.4597 4.54102 21.0098L4.54492 20.9189L5.12891 13.3262L5.15723 12.959H1.40039C1.0586 12.959 0.74112 12.794 0.543945 12.5225L0.466797 12.3994C0.282607 12.0552 0.303006 11.6373 0.519531 11.3125L7.51953 0.8125Z"
        fill="#394860"
        stroke="white"
        strokeWidth="0.682933"
      />
    </svg>
  </SvgIcon>
)
export default Bolt
